import JSEncrypt from 'jsencrypt'

export function getPasswordKey(value, publicKey) {
	if(!value) return ''
	const encryptor = new JSEncrypt()
	encryptor.setPublicKey(publicKey)
	const encryptedData = encryptor.encrypt(value)
	return encryptedData
}